<template>
  <div class="set-location">
    <div>
      <div class="settings">
        <div class="choose-units">
          <a
            @click="setUnits('mph')"
            :class="[
              'button',
              'units',
              'units--mph',
              modelValue === 'mph' ? 'units-selected' : '',
            ]"
          >
            {{ $t("speed-units.mph") }}
          </a>
          <a
            @click="setUnits('kmh')"
            :class="[
              'button',
              'units',
              'units--kmh',
              modelValue === 'kmh' ? 'units-selected' : '',
            ]"
          >
            {{ $t("speed-units.kmh") }}
          </a>
          <a
            @click="setUnits('kn')"
            :class="[
              'button',
              'units',
              'units--kn',
              modelValue === 'kn' ? 'units-selected' : '',
            ]"
          >
            {{ $t("speed-units.kn") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['modelValue'],
  emits: ['update:modelValue'],
  compatConfig: { COMPONENT_V_MODEL: false },
  methods: {
    setUnits(units) {
      this.$emit('update:modelValue', units);
    },
  },
};
</script>
